<template>
<div id="app">
    <headerSite 
      v-if="pageLoaded"
      :site="site" 
      :isBgLight="isBgLight" 
      :dotColor="dotColor"
      class="absolute" 
      :isLandingMounted="true"
      @setLang="changeLang"
      :currentLang="currentLang"
      />
    <div class="section-page">
      <router-view 
        @mountedPage="displayPage" 
        @dotColorToApp="displayDotColor($event)"
        @setLang="changeLang"
        :currentLang="currentLang"/>
    </div> 
    <footerSite v-if="pageLoaded" :site="site" :currentLang="currentLang"/>
    
</div>
</template>

<script>
import { mapState} from 'vuex';
const HeaderSite = () => import( /* webpackChunkName: "HeaderSite" */ '@/snippets/HeaderSite.vue')
const FooterSite = () => import( /* webpackChunkName: "FooterSite" */ '@/snippets/FooterSite.vue')
import langHandler  from '@/mixins/langHandler.js'

export default {
  name: 'App',
  metaInfo() {
    return {
      title: "Alasta",
      titleTemplate: "Alasta | " + ' %s',
      charset: 'utf-8',
      name: 'viewport', content: 'width=device-width, initial-scale=1'
    }
  },
   components: {
    HeaderSite,
    FooterSite,
  },
  mixins: [langHandler],
  data(){
    return {
      pageLoaded: false,
      dotColor: '#ff0038',
      isBgLight: true,
      currentLang: 'fr',
      langageSetup: false
    }
  },
  methods:{
    displayPage(payload){
      this.pageLoaded = true;
      this.isBgLight = payload.isBgLight;
    },
    displayDotColor(payload){
      this.dotColor = payload;
    },
    changeLang(payload){
      this.currentLang = payload
    },
  },
  computed: mapState(['site']),
  created() {
    this.$store.dispatch('loadSite');
  },
  watch:{
    $route(route) {
      this.currentLang = this.$i18n.locale = route.meta.lang;
      if(!this.langageSetup){
        this.defineLanguage();
        this.langageSetup = true;
      }
    },
  },
}

</script>

<style lang="scss">
@import 'node_modules/reset-css/sass/_reset';

* {
    box-sizing: border-box;
}
:root {
    --fs: 1rem;
    --lh: calc(1.25 * 1rem);
    --bgcolor: rgb(19, 19, 19);
    --lightBgcolor: rgb(247, 247, 247);
    --lighter--bgcolor: rgb(19, 20, 21);
    --fontcolor: rgb(255, 255, 255);
    --darkGrey: rgba(39, 39, 39, 1);
    --hover: rgb(150,150,150);
    --discret: rgb(206,206,206);
    --discret-dark: rgba(32, 34, 38, .7);
}

a,
a:active,
a:hover,
a:visited {
    @include transition(color .5s ease);
    color: var(--fontcolor);
    text-decoration: none;
    &:hover {
        color: var(--hover);
        &.link{
          &:after{
            background-color: var(--hover);
          }
        }
    }
    &.link{
      display: inline-block;
      position:relative;
      &:after{
        content: "";
        background-color: var(--fontcolor);
        @include transition(background .5s ease);
        width: 100%;
        height: .05em;
        position: absolute;
        display: inline-block;
        left: 0;
        bottom: .09em;
      }
    }
}

:focus {
  outline: none;
}

.darkMode{
  --bgcolor: rgb(255, 255, 255);
  --lighter--bgcolor: rgb(233, 233, 233);
  --fontcolor: rgb(0,0,0);
  svg path{
    fill: var(--fontcolor);
  }
  .switcher,
  #partners img,
  .main-header img,
  #app #team .agile .agile__actions .agile__nav-button{
   filter : invert(1);
  }
}

.error{
  .header--light{
    display:none!important;
  }
  &.darkMode, &.whiteMode{
    header, footer, section{
       --fontcolor: rgb(255, 255, 255);
    }
    #main-footer,
    .main-header{
      .switcher,img{
        filter : none;
      }
    }
  }
}

body,
html {
    font-size: 15px;
    line-height: var(--lh);
    color: #000;
    background-color:var(--lightBgcolor);
    z-index: -1;
}

#app {
    font-family: 'surtregular', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    margin:auto;
}

header {
  padding: 1.5rem;
  border-bottom: 1px solid var(--color);
  display: flex;
  justify-content: space-between;
  @media screen and (min-width:768px){
    padding: 2.3rem 2.9rem;
  }
}
section:not(.dropdown) {
    width: 100%;
    > .grid {
        &.content{
          max-width:2000px;
          margin:auto;
           padding: 3rem 0;
          @media screen and (min-width:1024px){
            padding: 5.667rem 0;
          }
        }
        &.content--bordertop{
          border-top: 1px solid #7F7F7F;
        }
        &.content--card{
          padding:2rem;
          @media screen and (min-width:1024px){
              padding: 5rem 6.9rem;
              margin:.3rem;
          }
          h1 + p{
            margin-top: .9rem;
          }
        }
    }
    &.padded{
      padding: 0 2rem;
      @media screen and (min-width:1024px){
        padding: calc(2.3 * var(--fs)) calc(6.05 * var(--fs));
      }
      &.page-header{
        padding-top: calc(4.3 * var(--fs) + 94px);
      }
    }
    &+section:not(.bloc--regular){
      padding-top: 3rem;
      @media screen and (min-width:1024px){
        padding-top: calc(1.8 * var(--fs));
      }
    }
}
.content--card{
  margin: 0 -2rem;
  background-color:#fff;
  box-shadow: 1px 1px 10px rgba(0,0,0,0.07);
  @include border-radius(2px);
  padding:2rem;
  @media screen and (min-width:1024px){
    padding: 4.7rem;
    margin:0;
  }
}

.flex{
  @include flexbox();
  flex-wrap: wrap;
  > *{
    flex:1 1 auto;
  } 
  @media screen and (min-width:768px){
    .half{
      width:50%;
    }
    .third{
      width: 33.33333%;
    }
    .w_100{
      width:100%;
    }
    .w_50{
      width:50%;
    }
    .w_33{
      width: 33.33333%;
    }
    .w_66{
      width: 66.66666%;
    }
  } 
  
}
.grid {
  display: grid;
  grid-gap: 0;
  grid-template-columns: repeat(1,1fr);
  &.c-4 {
    grid-gap: calc(4 * var(--fs)) calc(2 * var(--fs));
  }
  @media screen and (min-width:768px){
    &.c-3 {
      grid-template-columns: repeat(2,1fr);
    }
    &.c-4 {
      grid-template-columns: repeat(2,1fr);
    }
    &.c-5 {
      grid-template-columns: repeat(3,1fr);
      grid-gap: 6.4rem calc(6 * var(--fs));
    }
  }
  @media screen and (min-width:1024px){
    grid-gap: calc(7 * var(--fs));
    &.c-2 {
      grid-template-columns: repeat(2,1fr);
    }
    &.c-3 {
        grid-template-columns: repeat(3,1fr);
    }
    &.c-4 {
      grid-template-columns: repeat(3,1fr);
    }
    &.insert{
      grid-template-columns: 75% 1fr 25% 1fr;
      border-top:none!important;
      padding:0!important;
    }
  }
  @media screen and (min-width:1200px){
    &.c-4 {
      grid-template-columns: repeat(4,1fr);

    }
    &.c-5 {
        grid-template-columns: repeat(5,1fr);
        grid-gap: 6.4rem calc(6 * var(--fs));
    }
  }
}

.page-header{
  background: var(--lighter--bgcolor);
  color:#fff;
  position:relative;
  &:after{
    content: "";
    display: block;
    width: 100%;
    height: 12.95rem;
    background: var(--lighter--bgcolor);
    position: absolute;
    left: 0;
    top: 100%;
  }
}

h1.discret{
  color:var(--discret);
  font-size: 1.067rem;
  font-family: 'surtmedium_extended', helvetica, Arial, sans-serif;
  letter-spacing:0.44px;
  &.dark{
    color:var(--discret-dark);
  }
}

.title-regular{
  font-size: 1.6rem;
  font-family: 'surtmedium_extended', helvetica, Arial, sans-serif;
  letter-spacing:0.44px;
  color:var(--darkGrey);
  line-height: 1.4;
}

p.catch-line{
  font-family: 'surtmedium_extended',Helvetica, Arial, sans-serif;
  max-width:930px;
  margin: .95rem 0;
  letter-spacing:0.74px;
  line-height: 2.8rem;
  font-size: 1.733rem;
  line-height: 2.467rem;
  @media screen and (min-width: 1024px){
    font-size:3rem;
    line-height: 3.728rem;
  }
}

.section-title{
  padding:0;
  font-size:1.8rem;
  margin-bottom: 3rem;
  font-family: 'surtbold_extended', Helvetica, Arial, sans-serif;
  letter-spacing: 1px;
  line-height: 2.4rem;
  @media screen and (min-width:1024px) {
    margin-bottom: 6.333rem;
  }
}

.section-subtitle{
  letter-spacing:0.16px;
  font-family: 'surtregular', Helvetica, Arial, sans-serif;
  font-size:1.533em;
  line-height:2.600rem;
  color:rgba(0,0,0,.9);
  @media screen and (min-width:768px) {
    font-size:1.733rem;
    line-height:2.773rem;
  }
}

.dropdown{
  border-bottom: 1px solid rgba(151, 151, 151,.2);
  margin-bottom: 1.2rem;
  &:last-child{
    border-bottom:none;
    margin-bottom:0;
  }
  .dropdown-header{
    padding:0;
    margin-bottom:.8rem;
    cursor:pointer;
    position:relative;
    &:hover{
      .dropdown-button{
        opacity:1;
      }
    }
    h1{
      max-width: 75%;
      font-size: 1.2rem;
      line-height:2rem;
      font-family:'surtSemiBold_extended', Helevetica, Arial, sans-serif;
      letter-spacing:0.4px;
      @media screen and (min-width:768px){
        max-width:calc(100% - 35px);
        font-size: 1.733rem;
        line-height:2.667rem;
      }
      &.small-header{
        font-size: 1.333rem;
        font-weight:bold;
      }
    }
    .dropdown-button{
      width:24px;
      height:1px;
      position:absolute;
      top: 50%;
      right: 0;
      @include transform(translate(0, -50%));
      opacity:.5;
      @include transition(opacity .3s ease, height 0s ease);
      &:after{
        content:"";
        display:block;
        width:1px;
        height:24px;
        content: "";
        position: absolute;
        left: 50%;
        top: 50%;
        @include transform(translate(0, -50%));
        @include transition(transform .3s ease);
      }
    }
  }
  &--light{
    .dropdown-button, .dropdown-button:after{
      background: #000;
    }
    .dropdown-header h1{
      color:rgb(0, 0, 0);
    }
    .dropdown-content{
      color: rgba(32, 34, 38,.9);
    }
  }
  &--dark{
    .dropdown-button, .dropdown-button:after{
      background: #fff;
    }
    .dropdown-header h1{
      color:rgb(255, 255, 255);
    }
    .dropdown-content{
      color: rgba(255, 255, 255,.7);
    }
  }
  &.show{
    .dropdown-button{
      height:0;
      opacity:1;
      @include transition(opacity .3s ease, height 0s ease .3s);
      &:after{
         @include transform(translate(-50%, -50%) rotate(-90deg));
      }
    }
  }
}

.insert--content{
  padding: calc(1.5 * var(--fs));
  background-color: var(--lighter--bgcolor);
  @media screen and (min-width: 1024px){
    padding: calc(8 * var(--fs)) calc(8 * var(--fs)) calc(16 * var(--fs));
  }
}

.dropdown-content{
  font-size: 1rem;
  line-height:1.867rem;
  @media screen and (min-width:768px){
    font-size: 1.067rem;
    line-height:1.867rem;
  }
  p{
    margin-bottom:1.6rem;
  }
}

#map {
  width: 100%;
  height:400px;
  div[aria-label='Map marker']{
    svg g{fill:#000;}
  }
}

form{
    textarea,
    input{
      border:none;
      border-bottom:1px solid #333;
      background:none;
      width:100%;
      padding: 1rem;
      margin: 0 0 1rem 0;
      color:var(--fontcolor);
      font-family: 'surtregular', Helvetica, Arial, sans-serif;
      letter-spacing: .03rem;
      &:focus{
        outline: 1px solid grey;
      }
      &:-internal-autofill-selected {
          -webkit-appearance: menulist-button;
          background-color: #333 !important;
          background-image: none !important;
          color: -internal-light-dark-color(black, white) !important;
      }
    }
    button.submit{
      padding: .7rem 1rem .5rem;
      text-transform: uppercase;
      font-family: 'surtregular', Helvetica, Arial, sans-serif;
      letter-spacing: .03rem;
      border-radius: 0;
      background:lighten(#333, 20%);
      border: none;
      cursor:pointer;
      color:var(--fontcolor);
      &:hover{
        background:lighten(#333, 10%);
      }
    }
    ::placeholder {
      color: #333;
      font-size: 1.5em;
      font-family: 'surtregular', Helvetica, Arial, sans-serif;
    }
  }

  span{
    line-height: 1.10rem;
    &.success{
      color: #41BF84;
    }
    &.alert{
      color: #F21628;
    }
  }

.align-right{
  text-align:right;
}

.hidden{
  display:none!important;
}

.figure--square{
  height:0;
  position:relative;
  padding-bottom:100%;
  border-radius: 2px;
  overflow: hidden;
  img{
    width:100%;
    height:100%;
    position: absolute;
    top:0;
    left:0;
    bottom:0;
    right:0;
    object-fit:cover;
  }
}

.small-thumb{
  height:0;
  position:relative;
  // padding-bottom:87.5%;
  padding-bottom: 65%;
  overflow: hidden;
  img{
    width:100%;
    height:100%;
    position: absolute;
    top:0;
    left:0;
    bottom:0;
    right:0;
    object-fit:cover;
  }
}

#collaborations .agile__actions{
    position: absolute;
    @include transform(translate(-50%, -50%));
    width:100%;
    top:50%;
    left:50%;
    .agile__nav-button{
      background: none;
      border: none;
      font-size: 0rem;
      width: 15px;
      height: 15px;
      cursor: pointer;
      &.agile__nav-button--next{
        border-right: 2px solid #fff;
        border-bottom: 2px solid #fff;
        @include transform(rotate(-45deg));
      }
       &.agile__nav-button--prev{
        border-left: 2px solid #fff;
        border-bottom: 2px solid #fff;
        @include transform(rotate(45deg));
      }
    }
  }

img{ width: 100%; }

img, figure, {
  @include transition(opacity .3s ease, filter .5s ease .5s);
  &.toLoad{
    opacity: 0;
    filter: blur(3px);
    img[lazy="loaded"]{
      filter: none;
    }
  }
  &[lazy="loaded"],
  &.loaded{
    opacity:1;
    filter: none;
  }
}

.slide-enter-active {
  @include transition(all .5s ease);
}
.slide-leave-active {
  -moz-transition-duration: 0.5s;
  -webkit-transition-duration: 0.5s;
  -o-transition-duration: 0.5s;
  transition-duration: 0.5s;
  -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}
.slide-enter-to, .slide-leave {
   max-height: 300px;
   overflow: hidden;
}

.slide-enter, .slide-leave-to {
   overflow: hidden;
   max-height: 0;
}

.slide-fade-enter-active {
  @include transition(all .5s ease .5s);
}
.slide-fade-leave-active {
  -moz-transition-duration: 0.3s;
  -webkit-transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}
.slide-fade-enter-to, .slide-fade-leave {
   opacity: 1;
   margin-top: 0;
}

.slide-fade-enter, .slide-fade-leave-to {
  opacity: 0;
   margin-top: 1em;
}

.inView-section{
  opacity: 0;
  transition: opacity .3s ease;
}

.inView-section[data-visible]{
  opacity: 1;
}

.tippy-tooltip {
  background-color:#fff;
  font-family:surtbold_extended;
  color:#000; 
  padding:0.667rem 1.467rem;
  font-size:1.067rem;
  .tippy-arrow{
    border-top-color:#FFF!important;
    border-bottom-color:#FFF!important;
 }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s ease .3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.section-page{
  min-height:100vh;
}


</style>
